/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import { useState } from 'react'

import { Dialog, IconButton } from '@mui/material'
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'
import Icon from '@mui/material/Icon'

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import { useMaterialUIController } from 'context'

function AdminUserControl(): JSX.Element {
	const [controller, _] = useMaterialUIController()
	const { session } = controller
	const [dialogOpen, setDialogOpen] = useState<boolean>(false)

	return (
		<Card id="sessions">
			<Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
				<MDBox width={500} height={150} style={{ backgroundColor: '#fff' }}>
					<MDBox
						p={3}
						display={'flex'}
						flexDirection={'column'}
						justifyContent={'center'}
						alignItems={'center'}
						width={'100%'}
						gap={1}
					>
						<MDTypography variant="h4">Add Users</MDTypography>
						<MDTypography variant="body2" textAlign="center">
							Please email&nbsp;
							<MDTypography variant="body2" fontStyle="italic" component="span">
								michael@tazirides.co.uk
							</MDTypography>{' '}
							to add a user to your organisation.
						</MDTypography>
					</MDBox>
				</MDBox>
			</Dialog>
			<MDBox p={3} lineHeight={1}>
				<MDBox
					display={'flex'}
					flexDirection={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<MDBox>
						<MDBox mb={1}>
							<MDTypography variant="h5">Admin User Control</MDTypography>
						</MDBox>
						<MDTypography variant="button" color="text" fontWeight="regular">
							This is the users associated with your organisation.
						</MDTypography>
					</MDBox>
					<MDButton color="primary" variant="outlined" onClick={() => setDialogOpen(true)}>
						+ add new user
					</MDButton>
				</MDBox>
			</MDBox>
			<MDBox pb={3} px={3} sx={{ overflow: 'auto' }}>
				{session.data.organisation?.members.map((member, index) => {
					return (
						<MDBox
							key={index}
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							width={{ xs: 'max-content', sm: '100%' }}
							py={2}
						>
							<MDBox display="flex" alignItems="center" width={'100%'}>
								<MDBox textAlign="center" color="text" px={{ xs: 0, md: 1.5 }} opacity={0.6}>
									<Icon color={member.role === 'ADMIN' ? 'primary' : 'secondary'}>star</Icon>
								</MDBox>
								<MDBox
									height="100%"
									display={'flex'}
									flex={4}
									flexDirection={'column'}
									ml={2}
									lineHeight={1}
									mr={2}
								>
									<MDTypography
										display="block"
										variant="button"
										fontWeight="regular"
										color={member.role === 'ADMIN' ? 'primary' : 'secondary'}
									>
										{member.email}
									</MDTypography>
									<MDTypography variant="caption" color="text">
										UID: {member.uid}
									</MDTypography>
								</MDBox>
								<MDBox display="flex" alignItems="center" flex={1} pl={10}>
									<MDBox display="flex" alignItems="center" justifyContent="flex-end" mr={2}>
										<MDTypography variant={'h6'}>
											{member.role.charAt(0) + member.role.slice(1).toLowerCase()}
										</MDTypography>
									</MDBox>
								</MDBox>

								<IconButton
									size="medium"
									aria-label="delete"
									color="error"
									onClick={() => {
										setDialogOpen(true)
									}}
								>
									<Icon fontSize="medium">delete</Icon>
								</IconButton>
							</MDBox>
							<Divider />
						</MDBox>
					)
				})}
			</MDBox>
		</Card>
	)
}

export default AdminUserControl
